module.exports = __webpack_public_path__ + "media/assets/images/tour/3_Tour_2-b3d8ff4bab1f63a4be905959644640b7.png";